import { Column } from 'primereact/column';
import { DataTable } from 'primereact/datatable';
import React from 'react'
import ContenedorTabla from '../../../common/ContenedorTabla';
const SubcategoriasMantenimientoTabla = (props) => {
    return (
        <ContenedorTabla titulo="">
            <DataTable key={"subcats"} globalFilter={props.globalFilter} selectionMode="single" className="tabla-actividades"
                emptyMessage="No hay resultados" value={props.tablaLineasSubcategorias} onRowClick={props.editarActividad} >
                <Column className='w-100' field="nombreCategoria" header="Categoría" sortable />
                <Column className="p-col-3 " field="indice" header="Índice" sortable />
                <Column className='w-100' field="nombre" header="Nombre" sortable />
                <Column className='w-100' field="numActividades" header="# actividades" sortable />
            </DataTable>
        </ContenedorTabla>)
}
export default SubcategoriasMantenimientoTabla;